
function SdStatusSubtitlesCtrl(TranslationService, StoreService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.options = [];
    ctrl.loaded = false;

    ctrl.onToggle = function (open) {
        //console.log('on Toggle', open);
        if (open && !ctrl.loaded) {
            ctrl.loadStatusTypes();
        }
    }


    ctrl.loadStatusTypes = function () {
        StoreService.getStatusList('').then(
            function (result) {
                ctrl.loaded = true;
                ctrl.quotes = result.data
                    .filter(function (item) {
                        return item.Group == 'QUOTE'
                    })
                    .map(function (item) {                    
                        return {
                            Group: item.Group,
                            Key: item.Key,
                            Value: ctrl.translation['Status_' + item.Value]
                        }                    
                    });
                ctrl.shippings = result.data
                    .filter(function (item) {
                        return item.Group == 'SHIPPING'
                    })
                    .map(function (item) {
                        return {
                            Group: item.Group,
                            Key: item.Key,
                            Value: ctrl.translation['Status_' + item.Value]
                        }                    
                    });
                //console.log('quotes', ctrl.quotes, ctrl.shippings)
            }, function () {
                ctrl.loaded = true;
            }
        );
    }

    //function transformQuote(item) {
    //    return {
    //        Group: item.Group,
    //        Key: item.Key,
    //        Value: ctrl.translation['Status_' + item.Value]
    //    };

    
}

SdStatusSubtitlesCtrl.$inject = ['TranslationService', 'StoreService'];

seedWebApp.component('sdStatusSubtitles', {
    controller: SdStatusSubtitlesCtrl,
    controllerAs: 'ctrl',
    bindings: {
    },
    templateUrl: '/SPA/Components/sd-status-subtitles.html' + seedWebApp.buildVersion
});